// extracted by mini-css-extract-plugin
export var button = "_redotech-arbiter-lib-redo-button-close-x-button";
export var hasDarkBackground = "_redotech-arbiter-lib-redo-button-close-x-has-dark-background";
export var hasLightBackground = "_redotech-arbiter-lib-redo-button-close-x-has-light-background";
export var iconWrapper = "_redotech-arbiter-lib-redo-button-close-x-icon-wrapper";
export var large = "_redotech-arbiter-lib-redo-button-close-x-large";
export var medium = "_redotech-arbiter-lib-redo-button-close-x-medium";
export var small = "_redotech-arbiter-lib-redo-button-close-x-small";
export var xsmall = "_redotech-arbiter-lib-redo-button-close-x-xsmall";